/**
 * DF cart sample
 *
 * Panier latéral : case à cocher « Je souhaite recevoir mon échantillon ».
 *  - Cocher la case soumet le petit formulaire produit (<product-form>) de l'échantillon : le thème ajoute
 *    la ligne au panier et rafraîchit le panier latéral.
 *  - Si le panier repasse sous le minimum d'achat alors que l'échantillon est dans le panier, la ligne est
 *    retirée automatiquement (on clique sur le bouton « Supprimer » du thème).
 * Le rendu (case, note, ligne) est fait par sections/df-cart-drawer.liquid.
 */
(function () {
  if (window.__dfCartSampleInit) return;
  window.__dfCartSampleInit = true;

  document.addEventListener('change', function (e) {
    var box = e.target;
    if (!box || !box.matches || !box.matches('[data-df-sample-toggle]') || !box.checked) return;

    var form = box.closest('form');
    if (!form) return;

    box.disabled = true;

    if (form.requestSubmit) {
      form.requestSubmit();
    } else {
      form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }
  });

  function enforceMinimum() {
    var flag = document.querySelector('[data-df-sample-below-min]');
    if (!flag || flag.__dfHandled) return;

    var removeButton = document.querySelector('line-item[data-df-sample] .line-item__remove-button');
    if (!removeButton) return;

    flag.__dfHandled = true;
    removeButton.click();
  }

  var timer = null;
  function schedule() {
    if (timer) return;
    timer = setTimeout(function () { timer = null; enforceMinimum(); }, 250);
  }

  if ('MutationObserver' in window) {
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  }

  enforceMinimum();
})();
